define(["./tripOperationHistoryModule"], function (tripOperationHistoryModule) {
    "use strict";

    return tripOperationHistoryModule.service("tripOperationHistoryService", ["$http", "tripOperationHistoryServiceUrl",
        function ($http, tripOperationHistoryServiceUrl) {

            return {
                findTripOperationHistoryUrlForNodeIdentifier: findTripOperationHistoryUrlForNodeIdentifier
            };

            function findTripOperationHistoryUrlForNodeIdentifier(nodeIdentifier, lastTripRevision) {
                return $http.post(tripOperationHistoryServiceUrl.getTripOperationHistoryUrlForNodeIdentifier(), nodeIdentifier, {
                    params: {
                        initialRevision: lastTripRevision,
                        maxResults: 5
                    }
                }).then(getData);
            }

            function getData(response) {
                return response.data;
            }
        }
    ]);
});